import { Button, Select } from 'antd';
import dayjs from 'dayjs';
// no React import needed with automatic JSX runtime
import type { TFunction } from 'i18next';
import KaratCalculator, { RowData } from '../KaratCalculator';

type Props = {
    t: TFunction;
    melts: Array<{ id: number; date: string }>;
    selectedMelt: number | null;
    onSelectMelt: (id: number) => void;
    onLoadStock: () => void;
    processRows: RowData[];
    loadedRows: RowData[];
    setMeltingData: (rows: RowData[]) => void;
    rowsEditable: boolean;
    afterMass?: number;
    afterKarat?: number;
    onAfterValuesChange: (m?: number, k?: number) => void;
    onLossesChange: (losses?: {
        lossGr: number;
        lossPercent: number;
        totalLossPercent: number;
    }) => void;
    onSaveMelt: () => void;
    onGenerateMeltingRecord: () => void;
    onMelt: () => void;
    meltingData: RowData[];
};

function MeltingContent({
    t,
    melts,
    selectedMelt,
    onSelectMelt,
    onLoadStock,
    processRows,
    loadedRows,
    setMeltingData,
    rowsEditable,
    afterMass,
    afterKarat,
    onAfterValuesChange,
    onLossesChange,
    onSaveMelt,
    onGenerateMeltingRecord,
    onMelt,
    meltingData,
}: Readonly<Props>) {
    return (
        <div>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    gap: '12px',
                    marginBottom: '16px',
                }}
            >
                <Select
                    placeholder={t('metals.selectMelting')}
                    style={{ width: '200px' }}
                    value={selectedMelt ?? undefined}
                    onChange={onSelectMelt}
                >
                    {melts.map(m => (
                        <Select.Option key={m.id} value={m.id}>
                            #{m.id} - {dayjs(m.date).format('YYYY-MM-DD')}
                        </Select.Option>
                    ))}
                </Select>
                <Button onClick={onLoadStock} style={{ minWidth: '120px' }}>
                    {t('metals.stock')}
                </Button>
            </div>
            <KaratCalculator
                initialRows={selectedMelt ? loadedRows : processRows}
                showDeleteColumn={false}
                columnNames={{ qty: t('metals.stock'), quantityToMelt: t('metals.quantityToMelt') }}
                onMeltingDataChange={setMeltingData}
                rowsEditable={rowsEditable}
                initialAfterMass={afterMass}
                initialAfterKarat={afterKarat}
                onAfterValuesChange={onAfterValuesChange}
                onLossesChange={onLossesChange}
            />
            <div>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        gap: '12px',
                        marginBottom: '16px',
                    }}
                >
                    {Boolean(selectedMelt) && (
                        <>
                            <Button
                                type="primary"
                                onClick={onSaveMelt}
                                style={{ minWidth: '120px' }}
                            >
                                {t('metals.save')}
                            </Button>
                            <Button onClick={onGenerateMeltingRecord} style={{ minWidth: '180px' }}>
                                {t('metals.meltingRecord')}
                            </Button>
                        </>
                    )}
                </div>

                {!selectedMelt && (
                    <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
                        <Button
                            type="primary"
                            onClick={onMelt}
                            disabled={!meltingData || meltingData.length === 0}
                            style={{
                                minWidth: '120px',
                                backgroundColor:
                                    !meltingData || meltingData.length === 0
                                        ? '#d9d9d9'
                                        : '#1890ff',
                                borderColor:
                                    !meltingData || meltingData.length === 0
                                        ? '#d9d9d9'
                                        : '#1890ff',
                            }}
                        >
                            {t('metals.melt')}
                        </Button>
                        <Button
                            onClick={onGenerateMeltingRecord}
                            disabled={!meltingData || meltingData.length === 0}
                            style={{ minWidth: '180px' }}
                        >
                            {t('metals.meltingRecord')}
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
}

export default MeltingContent;
